import { coalesce } from "@kazoohr/helpers";
import { ApolloError } from "../browser";

/**
 * Given an ambiguous error, this function returns a flattened set of translations
 * and their values in the error message and its descendants provided. Returns
 * undefined if there are no translatable errors anywhere within the Apollo error
 * tree.
 */
export function getTranslationsFromApolloError(
  error?: ApolloError
): undefined | [string, any][] {
  const translations: [
    translationKey: string,
    translationVariables: unknown
  ][] = [];

  const errorsCount = error?.graphQLErrors?.length;
  if (errorsCount && errorsCount > 0) {
    for (const gqlErr of error.graphQLErrors) {
      const translationKey = coalesce(
        gqlErr?.extensions?.translationKey,
        gqlErr?.extensions?.message
      );
      const translationValues: any = gqlErr?.extensions?.translationValues;
      if (translationKey && typeof translationKey === "string") {
        translations.push([String(translationKey), translationValues]);
      }
    }
  }

  if (translations.length === 0) {
    return undefined;
  }

  return translations;
}
